// Copy is intentionally hardcoded — edit it here, it is not CMS-configurable.
export const INTRO_BUBBLE_MESSAGE = "Hi, I'm an AI Assistant! How may I help you today?"

// A short beat so the launcher is noticed before the bubble pops up.
export const INTRO_BUBBLE_DELAY = 900

// Once dismissed, the intro stays hidden for the rest of the browser session.
export const INTRO_DISMISSED_STORAGE_KEY = 'msig-chatbot-intro-dismissed'
